<div class="products-list__filters__section-title font-2 font-weight-bold uppercase"
      (click)="toggleDropdown()"
      [ngClass]="{'is-active-dropdown' : _filter.expanded}"
>
    <div>
        <span class="color--primary-blue">{{ _filter.label | translate }}</span>
        <a *ngIf="hasSelectedItems" class="link link-underline small d-block btn-filter-item" (click)="clear()" href="javascript:void(0)">Clear</a>
    </div>
</div>

<div class="products-list__filters__dropdown font-3">
    <input *ngIf="isSearchAvailable" type="text" class="form-control filter-search"
           [(ngModel)]="_filter.searchTerm" (keyup)="keyUp.next($event)"
           placeholder="Type to search items"
    >

    <ul class="mt-2" style="overflow-y: auto; overflow-x: hidden" [ngStyle]="styles">
        <ng-container *ngFor="let item of _filter.items">
            <li *ngIf="item.isVisible && item.isValid">
                <div *ngIf="item.children.length > 0 && !flatten">
                    <ng-container *ngTemplateOutlet="filterParentLabel; context: { $implicit: item }"></ng-container>
                </div>
                <div *ngIf="item.children.length > 0 && flatten">
                    <ng-container *ngTemplateOutlet="filterParentLabelFlat; context: { $implicit: item }"></ng-container>
                </div>
                <div *ngIf="item.children.length <= 0 && !flatten">
                    <ng-container *ngTemplateOutlet="filterLabel; context: { $implicit: item }"></ng-container>
                </div>
            </li>
        </ng-container>
    </ul>
    <div class="mt-2 text-align-center" *ngIf="isChanged">
        <button class="btn btn-outline-primary" (click)="applyFilter()">Apply Filter</button>
    </div>
</div>

<ng-template #filterParentLabel let-item>
    <div>
        <label class="products-list__filters__parent custom-control custom-checkbox">
            <input value="{{ item.id }}" class="custom-control-input checkbox-dark-gray" type="checkbox" [(ngModel)]="item.selected" (change)="updateParentFilters(item)">
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description" [innerHTML]="item.label | safeContent "></span>
        </label>
        <ng-container *ngFor="let childItem of item.children">
            <span class="products-list__filters__sub-child filter-brands" *ngIf="childItem.isVisible && childItem.isValid">
                    <ng-container *ngTemplateOutlet="filterLabel; context: { $implicit: childItem }"></ng-container>
            </span>
        </ng-container>
    </div>
</ng-template>

<ng-template #filterParentLabelFlat let-item>
    <div>
        <ng-container *ngFor="let childItem of item.children">
            <span class=".products-list__flat-filters__sub-child filter-brands" *ngIf="childItem.isVisible && childItem.isValid">
                    <ng-container *ngTemplateOutlet="filterLabel; context: { $implicit: childItem }"></ng-container>
            </span>
        </ng-container>
    </div>
</ng-template>

<ng-template #filterLabel let-item>
    <label class="custom-control custom-checkbox js-checkbox" [attr.data-label]="item.label">
        <input value="{{ item.id }}" class="custom-control-input checkbox-dark-gray" type="checkbox" [(ngModel)]="item.selected" (change)="updateFilters()" >
        <span class="custom-control-indicator"></span>
        <span class="custom-control-description" [innerHTML]="item.label | safeContent "></span>
    </label>
</ng-template>
